<template>
  <div>
    <div v-for="(area, index) in extra_areas" :key="index" style="margin-bottom: 10px; display: flex; align-items: center;">
      <SelectContractArea 
        :area_ids="area.area_ids" 
        @onAreaChange="(data) => onAreaChange(data, index)"
        :pid="0"
        style="flex: 1;"
      />
      <el-button 
        type="danger" 
        icon="el-icon-delete" 
        size="small" 
        @click="removeArea(index)"
        style="margin-left: 10px;"
      >
        删除
      </el-button>
    </div>
    <el-button 
      type="primary" 
      icon="el-icon-plus" 
      size="small" 
      @click="addArea"
    >
      添加额外区域
    </el-button>
  </div>
</template>

<script>
import SelectContractArea from "./SelectContractArea";

export default {
  name: "SelectContractAreaMulti",
  components: {
    SelectContractArea
  },
  props: {
    area_ids: {
      type: String,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      extra_areas: [], // 额外区域列表，每个元素包含 {area_ids: "", contract_area: ""}
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.area_ids) {
        // extra_area_ids 格式为 "1,36,125;8;5" （用分号分隔不同区域）
        // 每个区域可能是完整路径，如 "1,36,125"
        const areaGroups = this.area_ids.split(';').filter(group => group.trim());
        this.extra_areas = areaGroups.map(group => ({
          area_ids: group.trim(),  // 完整路径ID，如 "1,36,125"
          contract_area: ''
        }));
      } else {
        this.extra_areas = [];
      }
    },
    addArea() {
      // 添加一个新的空区域选择器
      this.extra_areas.push({
        area_ids: '',
        contract_area: ''
      });
      this.emitChange();
    },
    removeArea(index) {
      // 删除指定索引的区域选择器
      this.extra_areas.splice(index, 1);
      this.emitChange();
    },
    onAreaChange(data, index) {
      // 当某个区域选择器变化时，更新对应的位置
      if (data && data.ids && data.ids.length > 0) {
        // 关键：extra_area_ids 只存储最终选中的区域ID（数组的最后一个元素）
        // 而不是整个层级路径
        const finalAreaId = data.ids[data.ids.length - 1];
        this.extra_areas[index].area_ids = String(finalAreaId);
        this.extra_areas[index].contract_area = data.pathData ? data.pathData.map(p => p.name).join(' -> ') : '';
      } else {
        this.extra_areas[index].area_ids = '';
        this.extra_areas[index].contract_area = '';
      }
      this.emitChange();
    },
    emitChange() {
      // 触发事件，传递所有额外区域的ID列表（用分号分隔不同区域）
      // 例如: "1,36,125;8;5" 表示3个区域，第一个是完整路径
      const all_ids = this.extra_areas
        .map(area => area.area_ids)
        .filter(id => id)
        .join(';');
      this.$emit('onAreaChange', all_ids);
    }
  },
  watch: {
    area_ids(newVal) {
      this.initData();
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SelectContractAreaMulti.vue